@if (product()?.data?.warranty) {
<div class="p1"
     [innerHTML]="product().data.warranty"></div>
}